import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';

export default {
  title: 'Live Status',
  attributeName: 'liveStatus',
  fields: [
    {
      attributeName: 'eventId',
      label: 'EventId',
      default:'(new)',
      required: true,
      disabled:true,
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Event ID',
      helpText: 'Event ID.',
      className:'col-sm-4'
    },
    {
      attributeName: 'name',
      label: 'Event name',
      default:'',
      required: true,
      disabled:true,
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Event name',
      helpText: 'Event name.',
      className:'col-sm-4'
    },
    {
      attributeName: 'startIngestAt',
      label: 'Start Ingest At',
      default:'',
      required: true,
      disabled:true,
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Start ingest at defined',
      className:'col-sm-4',    
    },
   
    {
      attributeName: 'status_deployment',
      label: 'Deployment',
      helpText: 'Status of Deployment.',
      type: FormInputTypes.STATUS,
      secondaryValue: 'deployment_log',
      className:'col-sm-3',
      tooltipPosition:'top',
      width: '10rem',
      colors: {
        not_connected: 'bg-gray',
        ready: 'bg-success',
        starting: 'bg-warning',
        shutting_down:'bg-warning',
        down:'bg-warning',
        stopping: 'bg-warning',
        pending: 'bg-warning',
        started: 'bg-success',
        up:'bg-success',
        error: 'bg-danger',
        fatal: 'bg-danger',
      },
    },
    {
      attributeName: 'status_live',
      type: FormInputTypes.STATUS,
      placeholder: 'Live status',
      secondaryValue: 'live_log',
      className:'col-sm-3',
      label: 'Live Status',
      tooltipPosition:'top',
      width: '10rem',
      canOrder: true,
      colors: {
        draft: 'bg-info',
        draft_template: 'bg-info',
        yaml_sent:'bg-warning',
        cloud_starting:'bg-warning',
        cloud_started:'bg-success',
        cloud_stopping:'bg-warning',
        cloud_stopped:'bg-warning',
        cloud_pending:'bg-warning',
        ingest_starting:'bg-warning',
        ingest_stopping:'bg-warning',
        ingest_stopped:'bg-warning',
        ingest_started:'bg-success',
        error:'bg-danger',
        open: 'bg-warning',
        close: 'bg-danger',
        not_ready: 'bg-danger',
        ready: 'bg-warning',
        publishing_video: 'bg-success',
      },
    },
    {
      attributeName: 'status_cloud',
      label: 'Cloud status',
      helpText: 'Status of Cloud event.',
      type: FormInputTypes.STATUS,
      secondaryValue: 'cloud_log',
      className:'col-sm-3',
      tooltipPosition:'top',
      width: '10rem',
      button:{'title':'Stop XMS Cloud Status',
        'confirmMessage':'You are about to stop the cloud ONLY in XMS, only if there was any error in the comunication between XMS and liveBackendAPI, if you are sure just DO IT!, if not, better ask someone else. But be careful, nothing is sent to LiveBackendAPI, it is a XMS´ thing',
        'reconfirmMessage':'¿Are you totally sure?',
        'actionUrl':'liveCloudForceStop'},
      colors: {
        not_connected: 'bg-gray',
        init_start: 'bg-warning',
        starting: 'bg-warning',
        shutting_down:'bg-warning',
        down:'bg-warning',
        stopping: 'bg-warning',
        stopped:'bg-warning',
        pending: 'bg-warning',
        started: 'bg-success',
        up:'bg-success',
        error: 'bg-danger',
        fatal: 'bg-danger',
        forced_stop:'bg-warning'
      },
    },
    {
      attributeName: 'status_ingest',
      label: 'Ingest status',
      helpText: 'Status of Ingest event.',
      type: FormInputTypes.STATUS,
      secondaryValue: 'ingest_log',
      className:'col-sm-3',
      tooltipPosition:'top',
      width: '10rem',
      button:{'title':'Stop XMS Ingest Status',
      'confirmMessage':'You are about to stop the ingest ONLY in XMS, only if there was any error in the comunication between XMS and liveBackendAPI, if you are sure just DO IT!, if not, better ask someone else. But be careful, nothing is sent to LiveBackendAPI, it is a XMS´ thing',
      'reconfirmMessage':'¿Are you totally sure?',
      'actionUrl':'liveIngestForceStop'},
      colors: {
        not_connected: 'bg-gray',
        starting:'bg-warning',
        stopping: 'bg-warning',
        pending:'bg-warning',
        started:'bg-success',
        stopped:'bg-warning',
        enqueued: 'bg-info',
        processing: 'bg-info',
        success: 'bg-success',
        error: 'bg-danger',
        fatal: 'bg-danger',
        forced_stop:'bg-warning'
      },
    },
    
  ],
};
